import Style from "./StatusCard.module.scss";

const StatusCard = ({ title, count }) => {
  const varientClass = title === "Cancelled" ? Style.cancelled : title === "Rejected" ? Style.rejected : title==="Returned" ? Style.returned : "";
  return (
    <div className={`${Style.card} ${varientClass}`} >
      <div className={Style.header}>
        {title}
      </div>
      <div className={Style.count}>{count}</div>
    </div>
  );
};

export default StatusCard;
